<template>
  <section class="home-block pb-0">
    <div class="container">
      <div ref="content" class="content">
        <div ref="title" class="title">
          <slot name="title">
            <h2>Варианты покупки</h2>
          </slot>
        </div>
      </div>
      <div class="text">
        <div class="text__content">
          Купите квартиру онлайн или офлайн. Оставьте заявку на просмотр и наш
          менеджер свяжется с Вами <br />
          или выберите квартиру самостоятельно.
        </div>
        <!--
          <div class="swiper-nav-top">
            <div class="swiper-button-prev" />
            <div class="swiper-button-next" />
          </div> -->
      </div>
      <div class="h3">Ипотека от банков-партнеров</div>
      <div v-if="mortgage" class="mortgage-table">
        <swiper
          v-if="addition_pay_program && addition_pay_program.length"
          navigation
          :slides-per-view="'auto'"
          :space-between="24"
          class="mortgage-feats hasPagination"
        >
          <swiper-slide v-for="(program, i) in addition_pay_program" :key="i">
            <div
              :class="['mortgage-feats__item', { primary: program.pay_hint }]"
            >
              <div class="mortgage-feats__background" />
              <div class="mortgage-feats__content d-flex flex-column">
                <div
                  v-if="program.pay_name"
                  class="h6 mortgage-feats__title"
                  v-html="program.pay_name"
                />
                <div
                  v-if="program.pay_text"
                  class="mortgage-feats__text mt-auto"
                  v-html="program.pay_text"
                />
                <div class="mortgage-feats__link">
                  <a
                    class="more-link stretched-link"
                    :href="program.pay_link || 'javascript:void(0)'"
                    @click="
                      !program.pay_link
                        ? $openPopupWithChat('Узнать подробнее')
                        : false
                    "
                  >
                    Подробнее
                  </a>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <table v-if="mq.lgPlus">
          <thead>
            <tr>
              <th>Банк</th>
              <th>Процентная ставка</th>
              <th>Первоначальный взнос</th>
              <th>Срок кредитования</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in mortgage.project_banks" :key="item.bank_name">
              <td class="p-0">
                <div v-if="item.bank_image_url" class="mortgage-table__logo">
                  <img
                    :src="item.bank_image_url"
                    loading="lazy"
                    width="168"
                    height="56"
                    :alt="item.bank_name"
                  />
                </div>
              </td>
              <td>от&nbsp;{{ item.bank_bet }}%</td>
              <td>от&nbsp;{{ item.bank_min_pay }}%</td>
              <td>до&nbsp;{{ item.bank_max_time }}&nbsp;лет</td>
              <td>
                <a
                  class="more-link"
                  href="javascript:void(0)"
                  data-popup-with-chats
                  data-popup-with-chats-title="Подробнее"
                  >Подробнее</a
                >
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="mortgage-mobile table-mobile">
          <div
            v-for="item in mortgage.project_banks"
            :key="item.bank_name"
            class="mortgage-mobile__item table-mobile__item"
          >
            <div v-if="item.bank_image_url" class="mortgage-mobile__logo">
              <img
                :src="item.bank_image_url"
                loading="lazy"
                width="168"
                height="56"
                :alt="item.bank_name"
              />
            </div>
            <div class="mortgage-mobile__info info info-small">
              <div class="info__row">
                <div class="info__td">
                  <span>Процентная ставка</span>
                </div>
                <div class="info__td">
                  <span>от&nbsp;{{ item.bank_bet }}%</span>
                </div>
              </div>
              <div class="info__row">
                <div class="info__td">
                  <span>Первоначальный взнос</span>
                </div>
                <div class="info__td">
                  <span>от&nbsp;{{ item.bank_min_pay }}%</span>
                </div>
              </div>
              <div class="info__row">
                <div class="info__td">
                  <span>Срок кредитования</span>
                </div>
                <div class="info__td">
                  <span>до&nbsp;{{ item.bank_max_time }}&nbsp;лет</span>
                </div>
              </div>
            </div>
            <div class="mortgage-mobile__more">
              <a
                class="more-link"
                href="javascript:void(0)"
                data-popup-with-chats
                data-popup-with-chats-title="Узнать подробнее"
                >Подробнее</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.min.css";
SwiperCore.use([Navigation]);
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  inject: ["mainStore", "mq"],
  data() {
    return {};
  },
  computed: {
    mortgage() {
      return this.mainStore.state.data?.mortgage;
    },
    addition_pay_program() {
      return this.mainStore.state.data?.installment?.addition_pay_program;
    },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
}

.h3 {
  display: flex;
  justify-content: center;
  margin-bottom: 72px;
  color: #545863;
  font-weight: 500;
  font-size: 48px;
}

.h6 {
  margin-bottom: 157px;
  color: #ff0020;
  font-weight: 500;
  font-size: 24px;
  text-transform: uppercase;
}

.text {
  margin-top: -15px;
  margin-bottom: 50px;
}

.text a {
  color: inherit;
}

.text__content {
  /* max-width: 700px; */
  color: #8e94a0;
  font-weight: 500;
  font-size: 18px;
  text-align: center;
}

body.-notouch .text a:hover {
  color: #205640;
}

.swiper-nav-top {
  position: static;
}

.mortgage-table {
  margin-bottom: 57px;
}

.mortgage-table td {
  padding: 36px 0;
  font-weight: normal;
  font-size: 20px;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
}

.mortgage-table th {
  text-align: center;
  padding-bottom: 24px;
}

.mortgage-table th:first-of-type {
  text-align: left;
}

.mortgage-table__logo {
  max-width: 168px;
  text-align: center;
}

.mortgage-table__logo img {
  object-fit: contain;
  width: auto;
  max-width: 100%;
  filter: grayscale(1);
}

.mortgage-mobile {
  padding-top: 0;
}

.mortgage-mobile__info .info__td:first-child {
  color: #8c8f8c;
}

.mortgage-mobile__logo {
  margin-bottom: 15px;
  text-align: center;
}

.mortgage-mobile__logo img {
  width: auto;
  max-width: 160px;
  height: auto;
  filter: grayscale(1);
}

.mortgage-mobile__more {
  margin-top: 15px;
}

.mortgage-feats {
  overflow: inherit;
  margin-bottom: 72px;
}

.mortgage-mobile__item.table-mobile__item {
  border-bottom: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
  margin-bottom: 0;
  padding: 24px 0;
}
.mortgage-mobile__item.table-mobile__item:last-child {
  padding: 24px 0;
}
@media (max-width: 991px) {
  .mortgage-mobile__more {
    display: flex;
    justify-content: center;
  }
}

@media (min-width: 768px) {
  .text {
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }

  .mortgage-feats {
    margin-top: 40px;
  }
}

.mortgage-feats .swiper-slide {
  width: 326px;
  height: auto;
}

.mortgage-feats__item {
  position: relative;
  height: 100%;
  border: 1px solid #e5e5e5;
  transition: color 0.1s, transform 0.2s, box-shadow 0.2s;
}

.mortgage-feats__item.primary {
  border-color: #509c3b;
}

.mortgage-feats__item.primary .mortgage-feats__title {
  color: #205640;
}

.mortgage-feats__background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #d3d0ff, #ff0020, #fff);
  opacity: 0;
  transition: opacity 0.1s;
}

/* .mortgage-feats__background::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("~@i/text-mask.png");
  background-position: 50% 50%;
  background-size: 420px 560px;
  opacity: 0.4;
} */

body.-notouch .mortgage-feats__item:hover,
body.-notouch .mortgage-feats__item:hover .mortgage-feats__title {
  color: #fff;
}

body.-notouch .mortgage-feats__item:hover {
  box-shadow: 0 10px 40px rgb(0 0 0 / 0.23);
  transform: translateY(-16px);
}

body.-notouch .mortgage-feats__item:hover .mortgage-feats__background {
  opacity: 1;
}

body.-notouch .mortgage-feats__item:hover .mortgage-feats__link a {
  color: #fff;
}

.mortgage-feats__content {
  position: relative;
  justify-content: space-between;
  height: 420px;
  padding: 32px 24px;
}

.mortgage-feats__text {
  font-size: 16px;
}

.mortgage-feats__link {
  margin-top: 15px;
}

@media (max-width: 767px) {
  .text {
    margin: -5px 0 40px;
    font-size: 16px;
  }

  .text__content {
    margin-bottom: 30px;
  }

  .mortgage-feats__content {
    padding: 24px;
  }

  .mortgage-feats__title {
    font-size: 24px;
  }
  
  .mortgage-feats {
    margin-bottom: 48px;
  }

  .more-link {
    font-size: 20px;
  }
}

@media (max-width: 575px) {
  .mortgage-feats__content {
    height: 240px;
  }

  .mortgage-feats__title {
    margin-bottom: 10px;
  }

  h2 {
    font-size: 36px;
  }

  .h3 {
    font-size: 28px;
    text-align: center;
  }
}

.mortgage-feats.hasPagination :deep(.swiper-button-prev),
.mortgage-feats.hasPagination :deep(.swiper-button-next) {
  margin-top: -50px;
}

@media (max-width: 767px) {
  .mortgage-feats.hasPagination :deep(.swiper-button-prev),
  .mortgage-feats.hasPagination :deep(.swiper-button-next) {
    margin-top: -41px;
  }
}
</style>
